import { Component, OnInit, Input } from "@angular/core";
import { WebRecentActivity } from "src/app/models";
import { MatDialog } from "@angular/material/dialog";
import { TransactionsDialogComponent } from "../../transactions/transactions-dialog/transactions-dialog-component";
@Component({
  selector: "app-recent-activity-item",
  templateUrl: "./recent-activity-item.component.html",
  styleUrls: ["./recent-activity-item.component.scss"]
})
export class RecentActivityItemComponent implements OnInit
{

  @Input() activity: WebRecentActivity;
  height: string;
  branchCustId: string;


  constructor(
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void
  {
    if (this.activity.Type != "Delivery")
    {
      this.activity.Description = "";
    }
  }

  public getRecentActivityItem(): void
  {
    if (this.activity)
    {
      this.dialog.open(TransactionsDialogComponent, {
        width: "100%",
        height: this.height,
        maxWidth: 950,
        data: { transaction: this.activity },
        restoreFocus: true,
      });
    }

  }

  get color(): string
  {
    let value = "black";
    switch (this.activity.Type)
    {
      case "Delivery":
        value = "red";
        break;
      case "Payment":
        value = "green";
        break;
      case "Service Call":
      default:
        value = "black";
        break;
    }

    return value;
  }

}
